<template>
  <div v-if="!loading">
    <InputHider v-show="!lyrics" :toggle-class="'lyrics'" :save-handler="createLyrics" :points-gained="user ? points : 0" :placeholder="'Pridaj text'">
      <ckeditor :editor="editor" v-model="editorText" :config="createConfig"></ckeditor>
    </InputHider>

    <div v-if="lyrics" class="mt-15px">
      <UserCreationPanel :user="lyrics.user" :created="lyrics.created" />

      <!-- EDIT -->
      <div class="d-flex align-items-center justify-content-between mt-5px" v-if="lyrics.canEdit && !editMode">
        <button class="btn btn-link p-0" @click="this.editMode = !this.editMode">
          Upravit
        </button>

        <button class="btn btn-link p-0" @click="deleteLyrics">
          Odstrániť
        </button>
      </div>

      <div v-if="editMode">
        <span class="d-block mt-10px"></span>

        <ckeditor :editor="editor" v-model="editorText" :config="editConfig" :style="{ height: '300px' }"></ckeditor>

        <div class="mt-10px">
          <button class="btn btn-primary" @click="updateLyrics" role="button">Uložiť</button>
          <button class="btn btn-secondary ms-5px" role="button" v-if="lyrics.canEdit" @click="this.editMode = !this.editMode">
            Zrušiť
          </button>
        </div>
      </div>

      <div v-show="!editMode" class="mt-10px">
        <LyricsText :lyrics="lyrics" :text="lyrics.textAnnotated" :comment-points="commentPoints" @reload-lyrics-text="reloadLyricsText" />
      </div>

      <!-- EDIT -->
      <div class="d-flex align-items-center justify-content-between mt-5px" v-if="lyrics.canEdit && !editMode">
        <button class="btn btn-link p-0" @click="this.editMode = !this.editMode">
          Upravit
        </button>

        <button class="btn btn-link p-0" @click="deleteLyrics">
          Odstrániť
        </button>
      </div>

      <!-- CHANGE REQUEST -->
      <div class="d-flex align-items-center justify-content-between mt-5px" v-if="user && !lyrics.canEdit && !editMode">
        <button class="btn btn-link p-0" @click="this.editMode = !this.editMode">
          Navrhni zmeny
        </button>

        <Report v-if="!editMode && lyrics.canReport" :entity-id="lyrics.id" :entity-value="'text'" :entity-name="'fk_lyrics'" :side="'start'" />
      </div>
    </div>
  </div>
</template>

<script>
import { getLyricsBySong, createLyrics, updateLyrics, deleteLyrics } from "../helpers/LyricsApi";
import {lyricsConfig, lyricsConfigCreate} from "../ckeditor/configs";
import Lyrics from "../Lyrics/Lyrics.vue";
import LyricsText from "../Lyrics/LyricsText.vue";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import InputHider from "../InputHider/InputHider.vue";
import Report from "../Report/Report.vue";
import UserCreationPanel from "../User/UserCreationPanel.vue";

export default {
  name: "SongLyrics",
  inject: ['user'],
  components: { Lyrics, LyricsText, InputHider, Report, UserCreationPanel },
  data() {
    return {
      editor: ClassicEditor,
      editorText: '',
      createConfig: lyricsConfigCreate,
      editConfig: lyricsConfig,
      lyrics: null,
      fk_song: null,
      loading: true,
      editMode: false,
      disableLyricsText: false,
      reloadInterval: null,
      points: 0,
      commentPoints: 0,
    }
  },
  watch: {
    editMode(edit) {
      this.editorText = edit ? this.lyrics.text : this.editorText;
    },
  },
  methods: {
    createLyrics() {
      const data = {
        fk_song: this.fk_song,
        text: this.editorText
      }

      createLyrics(data).then(res => this.lyrics = res.data);
    },
    updateLyrics() {
      const data = {
        id: this.lyrics.id,
        text: this.editorText
      };

      updateLyrics(data).then(res => {
        this.lyrics = res.data;
        this.editMode = false;
      });
    },
    deleteLyrics() {
      deleteLyrics(this.lyrics.id).then(res => {
        this.lyrics = res.data;
        this.editMode = false;
      });
    },
    reloadLyricsText(forceReload) {
      if (!this.editMode) {
        getLyricsBySong(this.fk_song).then(res => {
          if (JSON.stringify(this.lyrics) !== JSON.stringify(res.data) || forceReload) {
            this.lyrics = res.data;
          }
        });
      }
    },
    reloadIntervalHandler() {
      if (!this.lyrics) {
        this.reloadInterval = setInterval(() => {
          this.reloadLyricsText();
        }, 5000);
      } else {
        clearInterval(this.reloadInterval);
      }
    }
  },
  mounted() {
    const parentNode = this.$el.parentNode;
    this.fk_song = parentNode.getAttribute('data-vue-song-lyrics');
    this.points = parseInt(parentNode.getAttribute('data-vue-points'));
    this.commentPoints = parseInt(parentNode.getAttribute('data-vue-comment-points'));

    getLyricsBySong(this.fk_song).then(res => this.lyrics = res.data);

    this.reloadIntervalHandler();
    this.loading = false;
  },
}
</script>
